import React, { memo } from 'react'
import styles from './AddedAppliance.module.scss'
import ViewAppliance from './ViewAppliance'
import EditApplianceInfo from './EditApplianceInfo'
import { ApplianceItem } from '../../../../../../../../model/solar-recommendation-form/appliance-item'

type Props = {
    appliance: ApplianceItem
    onChangeAppliance: (appliance: ApplianceItem) => void
    onChanges: (appliance: ApplianceItem) => void
    onRemove: (appliance: ApplianceItem) => void
}

const AddedAppliance: React.FC<Props> = memo((props: Props) => {
    const { appliance, onChanges, onRemove, onChangeAppliance } = props

    function styleContainer() {
        return appliance.editingProps.editing ? styles.editContainer : styles.viewContainer
    }

    function onSaveChanges(appliance: ApplianceItem) {
        if (appliance.editingProps.newAppliance) {
            appliance.appliance = appliance.editingProps.newAppliance
        }

        if (appliance.editingProps.quantity) {
            appliance.quantity = appliance.editingProps.quantity
        }

        if (appliance.editingProps.dailyUsage) {
            appliance.dailyUsage = appliance.editingProps.dailyUsage
        }

        appliance.editingProps = {
            editing: false,
            newAppliance: undefined,
            quantity: undefined,
            dailyUsage: undefined
        }

        onChanges(appliance)
    }

    function changeToEdit() {
        appliance.editingProps = {
            editing: true,
            newAppliance: undefined,
            quantity: appliance.quantity,
            dailyUsage: appliance.dailyUsage
        
        }
        onChanges(appliance)
    }

    function onDelete() {
        onRemove(appliance)
    }

    return (
        <div className={styles.container + ' ' + styleContainer()}>
            {
                appliance.editingProps.editing ? <EditApplianceInfo initialAppliance={appliance} onSaveChanges={onSaveChanges} onEditAppliance={onChangeAppliance} /> : <ViewAppliance appliance={appliance} onEdit={changeToEdit} onDelete={onDelete} />
            }
        </div>
    )
})

export default AddedAppliance